module.exports = __webpack_public_path__ + "media/bootstrap-icons/house-door-b9643113.svg";